// extracted by mini-css-extract-plugin
module.exports = {"paper":"Setup_paper__2Cs69","divider":"Setup_divider__3ew6m","header":"Setup_header__24ki0"};